var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDriverfill(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Driver_-_Fill",
    "data-name": "Driver - Fill",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M14,1a.857.857,0,0,1,.857.857v.857h4.286V7.857H17.412l2.354,6.467a3.429,3.429,0,1,1-6.515,2.1H9.606a3.43,3.43,0,0,1-6.685-.194A1.714,1.714,0,0,1,2,14.714V6.143a.857.857,0,0,1,.857-.857h6a.857.857,0,0,1,.857.857v4.286a.857.857,0,0,0,.857.857h1.714a.857.857,0,0,0,.857-.857V2.714H10.571V1Zm2.571,12.857a1.713,1.713,0,1,0,1.611,1.128l-.014-.037A1.715,1.715,0,0,0,16.571,13.857Zm-10.286,0A1.714,1.714,0,1,0,8,15.571,1.714,1.714,0,0,0,6.286,13.857ZM8,7H3.714V8.714H8Zm9.429-2.571H14.857V6.143h2.571Z",
    transform: "translate(-2 -1)",
    fill: "#002d44"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDriverfill);
export default __webpack_public_path__ + "static/media/driverfill.d1c11e5b7959da1dace00fed45131bf8.svg";
export { ForwardRef as ReactComponent };